<template>
  <v-container>
    <portal to="pageTitle">
      <span>Список всех событий</span>
    </portal>

    <v-card class="mx-auto" max-width="1200">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">Название</th>
            <th class="text-left">Дата</th>
          </tr>
          </thead>

          <tbody v-if="hasItems">
          <tr v-for="item in computedItems" :key="item.id">
            <td>
              <router-link :to="{ name: 'events__id',  params: { id: item.id } }"> {{ item.id }}
              </router-link>
            </td>
            <td v-html="getAllLocalValue(item.name)"/>
            <td v-html="item.date"/>
            <td>
              <img width="50px" :src="item.image"/>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import EventsListGQL from '../../graphql/private/Event/List.gql'
import Mixin from './components/Mixin'
import notify from '../../mixins/notify'

export default {
  mixins: [Mixin, notify],
  computed: {
    computedItems() {
      const l = this.eventList ? this.eventList.events : []
      return l.map(item => {
        console.log(item.date)
        item.date = item.date.substr(0, 10)
        return item
      })
    },
    hasItems() {
      return this.computedItems.length > 0
    },
  },
  apollo: {
    eventList: {
      query: EventsListGQL,
      variables: {
        paginate: {
          limit: 1000,
          page: 0,
        }
      }
    },
  },
}
</script>
